<template>
  <div class="footer">
    <div class="footer-content">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <div class="footer-logo">
              <div class="logo-box">
                <img src="../assets/image/footer-logo.png" alt="logo" />
              </div>
              <p>{{ $t("header.company") }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-ICP">
      <a
        href="http://icp.chinaz.com/home/info?host=xianhuize.net"
        target="_blank"
        >CopyRight 2017-2023 All Right Reserved ICP:陕ICP备2020013553号-1</a
      >
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {};
  },
  watch: {},
  computed: {},
  methods: {},
  created() {},
  mounted() {},
};
</script>
<style lang="less" scoped>
.footer {
  .footer-content {
    height: 150px;

    background: #dddddd;
    display: flex;
    align-items: center;

    .footer-logo {
      display: flex;
      justify-content: center;
      align-items: center;

      .logo-box {
        margin-right: 50px;
      }
      p {
        color: #333333;
        margin-bottom: 0;
        font-weight: bold;
        font-size: 22px;
      }
    }
  }
  .footer-ICP {
    height: 30px;
    background: #c0c0c0;
    a {
      display: block;
      text-align: center;
      line-height: 30px;
      color: rgba(51, 51, 51, 1);
      font-size: 14px;
    }
  }
}
//ipad  端样式
@media (max-width: 1024px) and (min-width: 768px) {
}
//手机端  端样式
@media (max-width: 767px) and (min-width: 320px) {
  .footer .footer-content .footer-logo .logo-box {
    width: 47px;
    height: 55px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .footer .footer-content .footer-logo p {
    font-size: 14px;
  }
  .footer .footer-content {
    height: 85px;
  }
  .footer .footer-ICP a {
    font-size: 10px;
  }
}
</style>